module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Helen Dickson\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Helen Dickson lives in South Yorkshire with her retired farm manager husband. On leaving school she entered the nursing profession, which she left to bring up a young family. Having moved out of the chaotic farmhouse, she has more time to indulge in her favourite pastimes. She enjoys being outdoors, travelling, reading and music. An incurable romantic, she writes for pleasure. It was a love of history that drove her to writing historical romantic fiction."), _c('Br', [_c('Br', [_vm._v(" "), _c('Br', [_c('Br', [_vm._v(" ")])], 1)], 1)], 1)], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/hRAuYy/tc-custom/9781460312490.jpg?1734032669661",
      "alt": "This image is the cover for the book Devil Claims a Wife"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Devil Claims a Wife\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("Forced into marriage by scandal, a woman must learn to trust her husband despite his dark past in this medieval romance.")]), _c('br'), _c('br'), _vm._v("Spoken of only in whispers—and with a name that strikes fear into the hearts of his enemies—Guy St. Edmond wields his ancient sword like the Devil and his charm like a weapon. Confronted with a woman who does not cower before him, he finds his interest is aroused—but Jane Lovet is betrothed to another."), _c('br'), _c('br'), _vm._v("Yet her engagement is soon broken by Guy’s ruthless intervention, causing a scandal that echoes around the royal court. Forced into marriage, he can’t deny that having the desirable Jane at his side night after night promises untold pleasures . . .\n    ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Harlequin\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5c3ee598","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0